import { Modal, Text } from '@lounge-fe/ui-kit'
import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { BenefitsData } from './types'
import { BenefitsModal } from './BenefitsModal'
import { IconMap } from './IconMap'

export const Benefits: ShopifySectionComponent<BenefitsData> = ({ data }) => {
  if (!data) return null

  return (
    <div className="careers-benefits-wrapper flex flex-col gap-11 items-center px-5">
      {data.title && (
        <Text variant="title-three" className="typography--display italic">
          {data.title}
        </Text>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-9 md:gap-y-7">
        {data.benefits?.hq &&
          data.benefits.hq.map((benefit, idx) => (
            <div key={idx} className="flex items-start gap-5">
              <span className="icon w-6 h-6">{IconMap[benefit.icon]}</span>
              <Text variant="title-five">{benefit.title}</Text>
            </div>
          ))}
      </div>
      <div className="flex flex-col items-center">
        {data.disclaimer && (
          <Text variant="body-sm" className="text-center">
            {data.disclaimer}
          </Text>
        )}
        {data.modal?.trigger_text && (
          <Modal>
            {({ onClose }) => (
              <>
                <Modal.Trigger>
                  <Text variant="body-sm" className="underline cursor-pointer">
                    {data.modal?.trigger_text}
                  </Text>
                </Modal.Trigger>
                <BenefitsModal onClose={onClose} data={data} />
              </>
            )}
          </Modal>
        )}
      </div>
    </div>
  )
}
